import React from "react";
import CopyableField from "./field";
import {InlineCopyableField} from "./inline-field";
import CopyableInput from "./input";

export {CopyableInput, CopyableField, InlineCopyableField};
